export const DATE_FORMAT = {
  // TODO: Extend and apply this constant https://robotsandpencils.atlassian.net/browse/AK-3262
  ISO_18601: "YYYY-MM-DD",
  US: "MM/DD/YYYY",
  US_DATE_TIME: "MM/DD/YYYY h:mma [UTC]",
  US_SHORT: "MM/DD/YY",
  EMAIL_TIMESTAMP: "ddd, MMM D, h:mm A",

  COMPANY_HEADER: "MM/YYYY",
} as const

export const EMPTY_DATE_PLACEHOLDER = "--/--/----"

export const UOM_RENDER_PRECISION = 2
export const CURRENCY_RENDER_PRECISION = 4
export const QUANTITY_RENDER_PRECISION = 0
export const DECIMALS_PRECISION = 5
export const UOM_ROUNDING_PRECISION = 4
export const UOM_CONVERSION_PRECISION = 10

// Formats an enum value into a user-friendly label (PREPAID_AND_ADD -> "Prepaid And Add")
export const formatEnumValue = (enumValue: string): string => {
  if (!enumValue) return enumValue
  return enumValue
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
